"use client";
import React, { forwardRef, memo, ReactElement, ReactNode } from "react";
import {
  FormControlLabel,
  FormControlLabelProps,
  Switch,
  SwitchProps,
} from "@mui/material";

const AppToggle = forwardRef<HTMLButtonElement, AppSwitchProps>(
  ({ sx, formControlLabelProps, label = "", ...otherProps }, ref) => {
    return (
      <FormControlLabel
        labelPlacement="start"
        control={
          <>
            <Switch
              ref={ref}
              sx={{
                width: 30,
                height: 16,
                padding: 0,
                "& .MuiSwitch-switchBase": {
                  height: "100%",
                  width: "16px",
                  color: "common.white",
                  padding: "2px",
                },
                "& .MuiSwitch-track": {
                  borderRadius: "13.3px",
                  height: "100%",
                  backgroundColor: "text.secondary",
                  opacity: 1,
                },
                "&& .Mui-checked+.MuiSwitch-track": {
                  backgroundColor: "darkgreen.main",
                },
                "& .MuiSwitch-thumb": {
                  width: 12,
                  height: 12,
                },
                ".MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked": {
                  color: "common.white",
                  transform: "translateX(13.66px)",
                },
                ".MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked:not(.Mui-disabled)":
                  {
                    "&+.MuiSwitch-track": {
                      opacity: 1,
                    },
                  },

                ...sx,
              }}
              {...otherProps}
            />
          </>
        }
        label={label}
        {...formControlLabelProps}
        sx={{
          gap: label ? "8px" : 0,
          margin: 0,
          ...formControlLabelProps?.sx,
        }}
      />
    );
  }
);
AppToggle.displayName = "AppToggle";
export default memo(AppToggle);
export type AppSwitchProps = SwitchProps & {
  label?: string | ReactElement | ReactNode;
  formControlLabelProps?: Omit<FormControlLabelProps, "control" | "label">;
};
